<template>
  <page-wrapper :title="title">
    <div class="header" v-if="!isCallCenter">
      <sc-button
        class="create-button"
        variant="primary"
        :route="createButton.route"
        >{{ createButton.text }}</sc-button
      >
    </div>
    <div>
      <collection-list-item
        v-for="item in list"
        :key="item.key"
        v-bind="item"
      ></collection-list-item>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import CollectionListItem from "../components/CollectionListItem";
import { baanRueJaiClient } from "@/dependencies";

export default {
  components: {
    PageWrapper,
    CollectionListItem,
    ScButton
  },
  data() {
    const title = "รายการแพ็กเกจใหญ่";
    const createButton = {
      text: "เพิ่มแพ็กเกจใหญ่",
      route: { name: "CollectionCreatePage" }
    };
    const list = [];

    return {
      title,
      list,
      createButton
    };
  },
  computed: {
    isCallCenter() {
      return localStorage.getItem("adminRoleId") == 4;
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupList();
    },
    async setupList() {
      const list = await this.fetchList();

      this.list = list.map(item => {
        const { id, image: imageUrl, name, package_ids } = item;

        return {
          id: id.toString(),
          imageUrl,
          name,
          packageCount: (package_ids || []).length,
          route: { name: "CollectionDetailPage", params: { id } }
        };
      });
    },
    async fetchList() {
      const response = await baanRueJaiClient.admin.subscriptions.collections.list();

      return response.data.result;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  padding: 30px;
  border-bottom: $border;
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/collections/pages/CollectionListPage.vue